module.exports = __webpack_public_path__ + "img/pr-26.33c7bfcd.png";